import {TTooltipCur} from 'containers/Tooltip/Container';
import 'containers/Tooltip/index.scss';
import {newWordsByWord} from 'modules/new-words-data';
import React, {FC} from 'react';
import {flatBem} from 'utils/bem';
import {Configurator} from 'utils/makeConfigurator';
import {capitalize} from 'utils/string';

const b = flatBem('Tooltip');

type Props = {
  data: {};
  conf: Configurator;
  cur: TTooltipCur | null;
};

const Component: FC<Props> = ({cur}) => {
  if (cur === null) return null;
  if (cur.type === 'WORD') {
    return (
      <div className={b()}>
        <div className={b('title')}>{capitalize(cur.word)}</div>
        <div className={b('description')}>
          {newWordsByWord.has(cur.word)
            ? newWordsByWord.get(cur.word)?.descr
            : `Слово ${JSON.stringify(cur.word)} не найдено`}
        </div>
      </div>
    );
  } else {
    return (
      <div className={b()}>
        <div className={b('title')}>{cur.type === 'WORD' ? null : null}</div>
        <div className={b('description')}>
          Слово <b>стресс</b> почти не встречается до второй половины XX века. В словаре Ушакова
          (1935–1940) оно появляется как специальный термин «Указатель цен, расценок на что нибудь».
          В 1970-е годы оно начинает употребляться в другом значении: этикетка с указанием цены:
          Украл ценник: салати зелени осень укусни/ 4р. [Георгий Елин. Из дневников и записных
          книжек (1980)]. А в 2000-е годы у слова ценник появляются разговорно-сниженные значения
          ‘цена’ (Единственное, что может сгубить новую «шестерку», ― это ее прайс-лист: все-таки
          ценник в миллион рублей может оказаться слишком тяжеловесным. [Дмитрий Великовский. Триумф
          воли // «Русский репортер», 2012) и ‘уровень цен’: Нам обязательно нужен был первый этаж,
          обязательно с отдельным входом ― и ценник в Москве сразу же умножается на 8, если речь о
          центральных улицах. [Сергей Карпов. Сергей Карпов: «Это прикольно, потому что ты ничего не
          контролируешь» // Афиша Daily, 2017].
        </div>
      </div>
    );
  }
};

export default Component;
